import { Box } from "@mui/material";
import type {
  GridPaginationModel,
  GridRowParams,
  GridRowSelectionModel,
  GridSortModel,
} from "@mui/x-data-grid";
import type React from "react";
import { useNavigate } from "react-router";
import { DataGrid } from "../../components/data-grid";
import { testCaseColumns } from "./columns";
import type { TestCase } from "./types";

interface TestCasesDataGridProps {
  testCases: TestCase[];
  isLoading: boolean;
  selectedTests: TestCase[];
  onSelectionChange: (selectedTests: TestCase[]) => void;
  total: number;
  paginationModel: GridPaginationModel;
  onPaginationModelChange: (model: GridPaginationModel) => void;
  sortModel: GridSortModel;
  onSortModelChange: (model: GridSortModel) => void;
}

export const TestCasesDataGrid: React.FC<TestCasesDataGridProps> = ({
  testCases,
  isLoading,
  selectedTests,
  onSelectionChange,
  total,
  paginationModel,
  onPaginationModelChange,
  sortModel,
  onSortModelChange,
}) => {
  const nav = useNavigate();

  const handleSelectionChange = (newSelection: GridRowSelectionModel) => {
    const selectedTestCases = testCases.filter((test) => newSelection.includes(test.id));
    onSelectionChange(selectedTestCases);
  };

  const handleRowClick = (params: GridRowParams<TestCase>) => {
    // Only navigate if it's a test type with test_data
    if (params.row.type === "test" && params.row.test_data?.id) {
      nav(`/tests-main/tests/${params.row.test_data.id}`);
    }
  };

  return (
    <Box sx={{ overflow: "auto" }}>
      <DataGrid
        loading={isLoading}
        rows={testCases}
        columns={testCaseColumns}
        pagination
        paginationMode="server"
        paginationModel={paginationModel}
        onPaginationModelChange={onPaginationModelChange}
        sortingMode="server"
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        pageSizeOptions={[10, 25, 50, 100]}
        rowCount={total}
        minHeight={`calc(100vh - 300px)`}
        checkboxSelection
        disableRowSelectionOnClick
        onRowSelectionModelChange={handleSelectionChange}
        rowSelectionModel={selectedTests.map((test) => test.id)}
        onRowClick={handleRowClick}
        customSx={{
          "& .MuiDataGrid-checkboxInput": {
            width: "20px",
            height: "20px",
          },
          "& .MuiDataGrid-checkboxInput input": {
            width: "20px",
            height: "20px",
          },
          "& .MuiDataGrid-columnHeader:first-of-type": {
            width: "50px !important",
            minWidth: "50px !important",
            maxWidth: "50px !important",
            padding: "0px 8px",
          },
          "& .MuiDataGrid-cell:first-of-type": {
            width: "50px !important",
            minWidth: "50px !important",
            maxWidth: "50px !important",
            padding: "0px 8px",
            justifyContent: "center",
          },
        }}
      />
    </Box>
  );
};
